import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'concatStringValues' })
/**
 * ConcactStringValues Pipe will return a string of concatenated
 * string values within an object of string key/value pairs separated
 * by ', ' characters
 *
 * Usage in the template: {{ obj | concatStringValues: arg1: arg2: arg3 }}
 */
export class ConcactStringValues implements PipeTransform {
  transform(obj: any, ...args: string[]): string {
    let value = '';
    args.forEach(arg => {
      /* Concatenate array of objects by key(arg) - to be expanded if needed */
      if (obj instanceof Array)
        obj.forEach(item => {
          if (typeof item[arg] === 'string') value += item[arg] + ', ';
        });

      if (obj?.[arg] && typeof obj[arg] === 'string')
        // if statment to prevent falsey arrayElement values in concatenated string
        value += obj[arg] + ', ';
    });
    // trim out last two characters ', '
    value = value.slice(0, -2);
    return value;
  }
}
